<template>
  <footer>
    <nav v-if="$route.name !== 'end'">
      <router-link
        class="prev"
        :to="{name: this.$route.meta.prev}"
        v-if="this.$route.meta.prev">
        Précédent
      </router-link>

      <router-link
        class="next"
        :to="{name: this.$route.meta.next}"
        :disabled="!isStepValid(this.$route.name)"
        v-if="this.$route.meta.next">
        Suivant
      </router-link>

      <button
        class="next"
        type="submit"
        :disabled="!isStepValid(this.$route.name) || $store.state.upload.status !== 'standby'"
        v-else>
        <span v-if="$store.state.upload.status === 'standby'">Valider</span>
        <span v-else>
          Chargement...
        </span>
        <progress v-if="$store.state.upload.status !== 'standby'" :value="$store.state.upload.progress" :max="$store.state.upload.total">
          {{$store.state.upload.progress}}/{{$store.state.upload.total}}
        </progress>
      </button>
    </nav>
    <nav v-else>
      <strong>Vous pouvez fermer cette fenêtre.</strong>
    </nav>
  </footer>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    computed: {
      ...mapGetters(['isStepValid'])
    }
  }
</script>

<style scoped lang="scss">
  @import '@/assets/_vars.scss';

  footer {
    background-color: color('background');
    padding: spacer(.75);
    margin-top: auto;
    box-shadow: 0 1px 0 color('background'); // Fix sometimes 1px overflow on Webkit
  }

  nav {
    max-width: 30rem;
    margin: auto;
    display: flex;
    padding: spacer(.25);
  }

  a, button {
    flex: 1 1 50%;
    appearance: none;
    padding: .75em 1em;
    border: none;
    text-decoration: none;
    text-transform: uppercase;
    text-align: center;
    transition: opacity 250ms;
    margin: spacer(.2);

    &.prev {
      background-color: white;
      color: color('secondaryBlue');
    }

    &.next {
      background-color: color('secondaryBlue');
      color: white;
    }

    &[disabled] {
      position: relative;
      z-index: 0;
      pointer-events: none;

      &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: -1;
        background-color: white;
        opacity: .75;
      }
    }

    span {
      position: relative;
    }
  }

  strong {
    margin: auto;
  }

  progress {
    appearance: none;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: -1;
    width: 100%;
    height: 100%;
    pointer-events: none;
    transition: opacity 250ms 250ms;

    &::-webkit-progress-bar {
      background: none;
    }

    &::-webkit-progress-value {
      background: color('secondaryBlue');
      transition : width 150ms;
    }
  }

  .help {
    &.end {
      text-align: center;
      width: 100%;
      display: block;

      a {
        color: #fff;
        font-size: 1.3em;
        text-decoration: none;
        font-weight: lighter;
      }
    }
  }
</style>
